export function youtubeBg() {
    document.getElementById('youtube-bg').onload = function () {
        document.getElementById('youtube-bg').className = "show";
    };
}


// WEBPACK FOOTER //
// ./assets/js/modules/youtubeBg.js